import { useDebounceCallback, useDebounceValue } from "usehooks-ts";

type FilterItem = { id: string; value: unknown };

type UserGroupFilterProps = {
  columnFilters: FilterItem[];
  setColumnFilters: (
    filters: (prevFilters: FilterItem[]) => FilterItem[]
  ) => void;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
};

const UserGroupMemberFilter = ({
  columnFilters,
  setColumnFilters,
  setPage,
  setPageSize,
}: UserGroupFilterProps) => {
  const [debouncedNameFilter] = useDebounceValue(
    (columnFilters.find(filter => filter.id === "name")?.value as string) || "",
    300
  );
  const [debouncedUsernameFilter] = useDebounceValue(
    (columnFilters.find(filter => filter.id === "userName")?.value as string) ||
      "",
    300
  );
  const [debounceEmailFilter] = useDebounceValue(
    (columnFilters.find(filter => filter.id === "email")?.value as string) ||
      "",
    300
  );

  const debounced = useDebounceCallback((id, value) => {
    setColumnFilters(prevFilters => {
      const updatedFilters = prevFilters.map(filter =>
        filter.id === id ? { ...filter, value } : filter
      );
      if (!prevFilters.find(filter => filter.id === id) && value !== "") {
        return [...updatedFilters, { id, value }];
      }
      return updatedFilters.filter(filter => filter.value !== "");
    });
    setPage(0);
    setPageSize(10);
  }, 300);

  return (
    <>
      <div className="mt-2 flex-grow">
        <input
          type="text"
          placeholder="Filter By Name"
          className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={debouncedNameFilter}
          onChange={e => debounced("name", e.target.value)}
        />
      </div>
      <div className="mt-2 flex-grow">
        <input
          type="text"
          placeholder="Filter By Username"
          className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={debouncedUsernameFilter}
          onChange={e => debounced("userName", e.target.value)}
        />
      </div>
      <div className="mt-2 flex-grow">
        <input
          type="text"
          placeholder="Filter By Email"
          className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={debounceEmailFilter}
          onChange={e => debounced("email", e.target.value)}
        />
      </div>
    </>
  );
};

export default UserGroupMemberFilter;
